import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import axios from "axios";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";

const MOB_Discard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [selectKeyword, setSelectKeyword] = useState('');
    const [selectStartDate, setSelectStartDate] = useState(appStore.YYYY_MM_01());
    const [selectEndDate, setSelectEndDate] = useState(appStore.YYYY_MM_DD());
    const [originRows, setOriginRows] = useState([]);
    const [discardList, setdiscardList] = useState([]);

    useEffect(() => {
        appStore.setLoading(true);

        // 권한 설정은 주석 처리된 상태
        const fromSearch = location.state?.fromSearch;
        if (fromSearch) {
            setSelectStartDate(fromSearch.selectStartDate || '');
            setSelectEndDate(fromSearch.selectEndDate || '');
            setSelectKeyword(fromSearch.selectKeyword || '');
        }

        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
            appStore.setLoading(false);
        }, 800);

    }, []);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSearch();
        }
    }, [MenuID]);

    const handleSearch = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/Discard/List',
            {
                params: {
                    search: selectKeyword
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            var array = response.data.map((item, index) => ({
                id: item.discard_id,
                discard_number: item.discard_number,
                discard_reason: item.discard_reason,
                discard_approval_user_id: item.discard_approval_user_id,
                discard_approval_user_name: item.discard_approval_user_name,
                reg_user_id: item.reg_user_id,
                reg_user_name: item.reg_user_name,
                recent_update_datetime: (item.update_datetime === undefined?Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss'):Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
            }));
            setOriginRows(response.data);
            setdiscardList([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false); 
        });
    };

    const handleRowClick = (discard_id) => {
        navigate(`/m/discard_detail/${discard_id}`, {
            state: {
                fromSearch: {
                    originRows: originRows.filter((originRows) => originRows.discard_id === discard_id),
                    selectStartDate: selectStartDate,
                    selectEndDate: selectEndDate,
                    selectKeyword: selectKeyword
                }
            }
        });
    };

    return (
        <div style={{ width: '100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' }}>
            <div className="M_menubox">
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                    <div style={{ float: 'right' }}>
                        <Button
                            onClick={handleSearch}
                            className="M_btn-p"
                            sx={{
                                m: 1,
                                fontSize: 15,
                                color: "white",
                                bdiscardColor: "#3D63AE",
                                backgroundColor: "#3D63AE",
                                ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                            }}
                            variant="outlined">
                            조회
                        </Button>
                    </div>
                </div>
            </div>

            <div className="M_contents">
                <div style={{ overflow: 'hidden' }}>
                    <div className="M_menu-keyword-sub-keyword" style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        }}>
                        <input
                            type="date"
                            value={selectStartDate}
                            onChange={(e) => setSelectStartDate(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        <span style={{ color: '#999' }}>~</span>
                        <input
                            type="date"
                            value={selectEndDate}
                            onChange={(e) => setSelectEndDate(e.target.value)}
                            style={{ flex: 1 }}
                        />
                        </div>
                    
                    <div className="M_menu-keyword-sub-keyword" style={{ width: '100%' }}>
                        <input
                        type="text"
                        placeholder="검색"
                        value={selectKeyword}
                        onChange={(e) => setSelectKeyword(e.target.value)}
                        style={{ width: '100%' }}
                        />
                    </div>
                </div>

                <div>
                    {discardList.length === 0 ? (
                        <p style={{ textAlign: 'center', color: '#aaa' }}>폐기정보가 없습니다.</p>
                    ) : (
                        discardList.map((discard) => (
                        <div
                            key={discard.id}
                            onClick={() => handleRowClick(discard.id)}
                            style={{
                            backgroundColor: '#fff',
                            bdiscardBottom: '1px solid #eee',
                            padding: '7px 8px',
                            fontSize: '14px'
                            }}
                        >
                            {/* ✅ 1줄: 폐기번호 + 폐기명 */}
                            <div style={{
                            fontWeight: 'bold',
                            fontSize: '16px',
                            color: '#222',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                            }}>
                            {discard.discard_number} / 승인자 : {discard.discard_approval_user_name?.trim() ? discard.discard_approval_user_name : '-'}
                            </div>

                            {/* ✅ 2줄: 폐기사유 */}
                            <div style={{
                            fontSize: '15px',
                            color: '#444',
                            marginTop: '4px', 
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                            }}>
                            {discard.discard_reason}
                            </div>

                            {/* ✅ 3줄: 수정자 | 일시 + 폐기상태 */}
                            <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '4px'  // 간격 통일
                            }}>
                            <div style={{ fontSize: '13px', color: '#888' }}>
                                {discard.reg_user_name} | {discard.recent_update_datetime}
                            </div>
                            </div>
                        </div>
                        ))
                    )}
                    </div>
            </div>
        </div>
    );
};

export default MOB_Discard;